import {TextAreaProps} from '../components/text-area';

export const getTextArea =
  <T>(data: Omit<TextAreaProps<T>, 'type'>) =>
  (): TextAreaProps<T> => ({
    ...data,
    type: 'text-area',
  });
